import React, { forwardRef } from 'react';
import { Field as ChakraField, HStack } from '@chakra-ui/react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  descriptionText?: React.ReactNode;
}

export const Field = forwardRef<HTMLDivElement, FieldProps>((props, ref) => {
  const { label, children, helperText, errorText, optionalText, descriptionText, ...rest } = props;
  return (
    <ChakraField.Root ref={ref} {...rest}>
      {label && (
        <HStack gap={2}>
          <ChakraField.Label>{label}</ChakraField.Label>
          <ChakraField.RequiredIndicator fallback={optionalText} />
          {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
        </HStack>
      )}
      {children}
      {descriptionText && <ChakraField.HelperText>{descriptionText}</ChakraField.HelperText>}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  );
});
